import { _AdvertisementBoxCustom as AdvertisementBoxCustom } from './advertisementBoxCustom'
import { Component, Mixins } from '@/vue-property-decorator'
import { _OuterBoxCustom as OuterBoxCustom } from './outerBoxCustom'
import BaseCssVarProvide from '../../../../components/baseCssVarProvide'
import BoxCut from '../../../components/boxCut'
import FallbackBackground, {
  FallbackBackgroundBase
} from '../../../components/fallbackBackground'
import FavoriteIcon from '../../../components/favoriteIcon'
import GameNameHorizontal from '../gameNameHorizontal'
import GameNameVertical from '../gameNameVertical'
import LabelGameStatus from '../../../components/labelGameStatus'
import MaskMaintain from '../../../components/maskMaintain'

class CssVarManager {
  outerBox = new OuterBoxCustom()
  boxCut = BoxCut.getCssVarDefault()
  // 不区分PC和H5形态,都使用相同的值
  fallbackBackground = {
    ...FallbackBackground.getCssVarDefault(),
    '--fallback-background-font-size': '1.03rem',
    '--fallback-background-z-index': '0'
  } as FallbackBackgroundBase
  advertisementBox = new AdvertisementBoxCustom()
  gameNameVertical = GameNameVertical.getCssVarSmall()
  gameNameHorizontal = GameNameHorizontal.getCssVarSmall()
  labelGameStatus = LabelGameStatus.getCssVarDefault()
  maskMaintain = MaskMaintain.getCssVarDefault()
  /** 收藏图标位置 */
  favoriteIcon = FavoriteIcon.getCssVarCircleDefault()
  /** 收藏图标尺寸 */
  circleStar = FavoriteIcon.CircleStar.getCircleStarDefault()
}
/** css变量控制器 此css仅能用于修改暴露的css样式,千万不要直接写一些额外的样式,不然容易出现异常 */
@Component<CssVarLarger>({
  name: 'CssVarLarger'
})
class CssVarLarger extends Mixins<BaseCssVarProvide<CssVarManager>>(
  BaseCssVarProvide
) {
  public static CssVarManager = CssVarManager
  /** 此布局下的基础样式值 */
  baseCssVarManager = () => new CssVarManager()
  // 渲染入口.
  render() {
    // 不需要通过css样式设置变量,则可以不用再包一层div了
    // return <div class={style['css-var-default']}>{this.$slots.default}</div>
    return this.$slots.default as unknown as VueTsxSupport.JSX.Element
  }
}
const _CssVarLarger = CssVarLarger
export default _CssVarLarger
